import React from 'react';
import { Button, Wrap, WrapItem } from '@chakra-ui/react';

interface QuickRepliesProps {
  onSelectReply: (message: string) => void;
  isLoading?: boolean;
}

const quickReplies = [
  {
    label: 'Tell me about Club App',
    message: 'Tell me about Club App',
  },
  {
    label: 'Request a Demo',
    message: 'I would like to request a demo',
  },
  {
    label: 'Pricing Information',
    message: 'Can you provide pricing information?',
  },
  {
    label: 'Contact Support',
    message: 'I need to contact support',
  },
];

const QuickReplies: React.FC<QuickRepliesProps> = ({
  onSelectReply,
  isLoading = false,
}) => {
  return (
    <Wrap spacing={2} justify='center' className='quick-replies-container'>
      {quickReplies.map((reply, index) => (
        <WrapItem key={index}>
          <Button
            size='sm'
            variant='outline'
            colorScheme='primary'
            onClick={() => onSelectReply(reply.message)}
            isDisabled={isLoading}
            className='quick-reply-button'
            borderRadius='full'
            px={4}
            fontSize='xs'
            fontWeight='medium'
            _hover={{
              transform: 'translateY(-2px)',
              boxShadow: 'md',
              bg: 'primary.50',
            }}
            transition='all 0.2s'
          >
            {reply.label}
          </Button>
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default QuickReplies;
